const communityBlocks = document.querySelectorAll(".feature-community-block");

communityBlocks.forEach(communityBlock => {
	const tabButtons = communityBlock.querySelectorAll(".js-tab-button");
	const tabs = [];

	tabButtons.forEach((button, index) => {
		tabs.push({
			index: index,
			photos: communityBlock.querySelector(`.tab-photos .tab[data-tab-id='${index}']`),
			content: communityBlock.querySelector(`.tab-content .tab[data-tab-id='${index}']`),
		});
		button.addEventListener("click", (e) => {
			const activeElement = e.target as HTMLElement;
			const index: null | string = activeElement.dataset?.tabId;

			tabButtons.forEach((el: HTMLElement) => {
				if (el.dataset.tabId == index) {
					el.classList.add("active");
				} else {
					el.classList.remove("active");
				}
			});
			tabs.forEach((tab) => {
				if (tab.index == index) {
					tab.photos.classList.add("active");
					tab.content.classList.add("active");
				} else {
					tab.photos.classList.remove("active");
					tab.content.classList.remove("active");
				}
			});
		});
	});
	if (tabButtons[0]) {
		const button = tabButtons[0] as HTMLButtonElement;
		button.click();
	}
})
